import { notification } from 'antd'
import { useMutation } from 'react-query'

import { DownloadExcelApi } from './api'

const useDownloadExcel = () => {
  const onError = () => {
    notification.error({
      message: 'Error al descargar el archivo',
    })
  }

  const onSuccess = (data: string) => {
    const a = window.document.createElement('a')

    a.href = data

    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const { mutate: downloadFile, isLoading } = useMutation(DownloadExcelApi.downloadExcelFile, {
    onSuccess: data => onSuccess(data.sapTptImportHistoryUrl),
    onError,
  })

  return {
    downloadFile,
    isLoading,
  }
}

export { useDownloadExcel }
